import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVloerbedekkingTegels1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M26 32H11l8-18.97h17z"
    />
    <path
      fill="#60D15D"
      d="M16.63 28.65a1.4 1.4 0 0 0 .09-.17l.1-.17.09-.18L17 28l.09-.17a1.4 1.4 0 0 0 .09-.17l.1-.17.09-.18.1-.17.09-.17c0-.06.07-.12.09-.17q.055-.087.1-.18l.09-.17.1-.17.09-.17.1-.18.09-.17a1.4 1.4 0 0 0 .09-.17l.1-.17.09-.18.1-.17.09-.17a1.4 1.4 0 0 0 .09-.17q.055-.087.1-.18l.09-.17.1-.17.09-.17.1-.18.09-.17.09-.17.1-.17.09-.18.1-.17.09-.17a1.4 1.4 0 0 0 .09-.17l.1-.18.09-.17.1-.17.09-.17c0-.06.07-.12.09-.17q.055-.087.1-.18l.09-.17.1-.17.09-.17q.051-.087.09-.18a1 1 0 0 0 .1-.17l.09-.17.1-.17.09-.18.1-.17.09-.17a1.4 1.4 0 0 0 .09-.17l.1-.18.09-.17.1-.17.1-.21q.051-.087.09-.18a1 1 0 0 0 .1-.17l.09-.17.1-.17.09-.18a1 1 0 0 0 .09-.17l.1-.17.09-.17.1-.18.09-.17.1-.17.09-.17c0-.06.07-.12.09-.17l.1-.18.09-.17.1-.17.09-.17q.051-.087.09-.18a1 1 0 0 0 .1-.17l.09-.17.1-.17.12-.18.1-.17.09-.17.09-.17.1-.18.09-.17a4.5 4.5 0 0 0 .53-2.17C25 9.32 22.31 7 19 7a6.09 6.09 0 0 0-5.54 3.18l-.09.17a1.4 1.4 0 0 0-.09.17l-.1.17-.09.18L13 11l-.09.17a1.4 1.4 0 0 0-.09.17 2 2 0 0 0-.1.18l-.09.17-.1.17-.09.17c0 .06-.07.12-.09.17a2 2 0 0 0-.1.18l-.09.17-.1.17-.09.17-.1.18-.09.17a1.4 1.4 0 0 0-.09.17l-.1.17-.09.18-.1.17-.09.17a1.4 1.4 0 0 0-.09.17 2 2 0 0 0-.1.18l-.09.17-.1.17-.09.17-.1.18-.09.17-.09.17-.1.17-.09.18-.1.17-.09.17a1.4 1.4 0 0 0-.09.17l-.1.18-.09.17-.1.17-.09.17c0 .06-.07.12-.09.17q-.055.087-.1.18l-.09.17-.1.17-.09.17a2 2 0 0 0-.09.18 1 1 0 0 0-.1.17l-.05.21-.1.17-.09.18-.1.17-.09.17a1.4 1.4 0 0 0-.09.17l-.1.18-.09.17-.1.17-.14.17a2 2 0 0 0-.09.18 1 1 0 0 0-.1.17l-.09.17-.1.17-.09.18a1 1 0 0 0-.09.17l-.1.17-.09.17-.1.17-.09.18-.1.17-.06.17c0 .06-.07.12-.09.17l-.1.18-.09.17-.1.17-.09.17a2 2 0 0 0-.09.18 1 1 0 0 0-.1.17l-.09.17-.1.17-.15.18-.1.17-.09.17-.09.17-.1.18-.09.17A4.5 4.5 0 0 0 5 26.83C5 29.68 7.69 32 11 32a6.09 6.09 0 0 0 5.54-3.18z"
    />
    <path
      fill="#B3E9B1"
      d="M11 32c3.314 0 6-2.315 6-5.17s-2.686-5.17-6-5.17-6 2.315-6 5.17S7.686 32 11 32"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M9.887 24.5A3.24 3.24 0 0 0 6.5 27.56a4.18 4.18 0 0 0 4.366 3.94h.045a5.36 5.36 0 0 0 5.589-5.085l.998.05A6.36 6.36 0 0 1 10.89 32.5a5.18 5.18 0 0 1-5.39-4.915v-.049A4.24 4.24 0 0 1 9.915 23.5a3.5 3.5 0 0 1 3.585 3.314l.002.025-.002.026a2.9 2.9 0 0 1-3 2.755A2.43 2.43 0 0 1 8 27.328l.998-.056a1.43 1.43 0 0 0 1.482 1.348h.04a1.9 1.9 0 0 0 1.978-1.78 2.5 2.5 0 0 0-2.573-2.34h-.04"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVloerbedekkingTegels1);

export default ForwardRef;
